import { render } from "./DateTimeSelectorV2.vue?vue&type=template&id=5768a046&scoped=true"
import script from "./DateTimeSelectorV2.vue?vue&type=script&lang=ts"
export * from "./DateTimeSelectorV2.vue?vue&type=script&lang=ts"

import "./DateTimeSelectorV2.vue?vue&type=style&index=0&id=5768a046&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5768a046"

export default script
import QField from 'quasar/src/components/field/QField.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField,QIcon,QBtn});
